module.exports = __webpack_public_path__ + "static/operational_and_process_excellence-6cbe95467c70daafa5474840a419ba1e.jpg";